/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://vd25phsi3rdvpmg5fxmnffyjzm.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-mmseuckam5c45bit3q2cbrw7vq",
    "aws_cognito_identity_pool_id": "eu-west-2:facbe1bd-9793-4e8c-8e5e-590eda41175d",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_keCa24c74",
    "aws_user_pools_web_client_id": "5uojiocrmso8uqvuhrjk1t971",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "myooladefc55adffe26d4e4189eae5aadd530db8ee129-dev",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
